import * as React from "react";
import { forwardRef } from "react";
const SvgPhPrinterLightOutline = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M83.8555 28.9062H77.3438V15.625C77.3438 15.0034 77.0968 14.4073 76.6573 13.9677C76.2177 13.5282 75.6216 13.2813 75 13.2812H25C24.3784 13.2813 23.7823 13.5282 23.3427 13.9677C22.9032 14.4073 22.6562 15.0034 22.6562 15.625V28.9062H16.1445C11.1211 28.9062 7.03125 32.7617 7.03125 37.5V68.75C7.03125 69.3716 7.27818 69.9677 7.71772 70.4073C8.15726 70.8468 8.7534 71.0938 9.375 71.0938H22.6562V84.375C22.6562 84.9966 22.9032 85.5927 23.3427 86.0323C23.7823 86.4718 24.3784 86.7188 25 86.7188H75C75.6216 86.7188 76.2177 86.4718 76.6573 86.0323C77.0968 85.5927 77.3438 84.9966 77.3438 84.375V71.0938H90.625C91.2466 71.0938 91.8427 70.8468 92.2823 70.4073C92.7218 69.9677 92.9688 69.3716 92.9688 68.75V37.5C92.9688 32.7617 88.8789 28.9062 83.8555 28.9062ZM27.3438 17.9688H72.6562V28.9062H27.3438V17.9688ZM72.6562 82.0312H27.3438V61.7188H72.6562V82.0312ZM88.2812 66.4062H77.3438V59.375C77.3438 58.7534 77.0968 58.1573 76.6573 57.7177C76.2177 57.2782 75.6216 57.0312 75 57.0312H25C24.3784 57.0312 23.7823 57.2782 23.3427 57.7177C22.9032 58.1573 22.6562 58.7534 22.6562 59.375V66.4062H11.7188V37.5C11.7188 35.3477 13.7031 33.5938 16.1445 33.5938H83.8555C86.2969 33.5938 88.2812 35.3477 88.2812 37.5V66.4062ZM77.3438 45.3125C77.3438 46.0851 77.1147 46.8403 76.6854 47.4827C76.2562 48.1251 75.6461 48.6257 74.9324 48.9214C74.2186 49.2171 73.4332 49.2944 72.6754 49.1437C71.9177 48.993 71.2217 48.6209 70.6754 48.0746C70.1291 47.5283 69.757 46.8323 69.6063 46.0746C69.4556 45.3168 69.5329 44.5314 69.8286 43.8176C70.1242 43.1039 70.6249 42.4938 71.2673 42.0646C71.9097 41.6353 72.6649 41.4062 73.4375 41.4062C74.4735 41.4062 75.4671 41.8178 76.1996 42.5504C76.9322 43.2829 77.3438 44.2765 77.3438 45.3125Z",
	fill: "#FA503C"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 3.74982,
	y1: 8.40783,
	x2: 90.2878,
	y2: 93.215,
	stroke: "#FA503C",
	strokeWidth: 5
}), /* @__PURE__ */ React.createElement("line", {
	x1: 6.94318,
	y1: 5.21447,
	x2: 93.4811,
	y2: 90.0217,
	stroke: "white",
	strokeWidth: 5
}));
const ForwardRef = forwardRef(SvgPhPrinterLightOutline);
export default ForwardRef;
